import { AxiosRequester } from './requesters/AxiosRequester';

export default class RequestService {
  static create(id: string): AxiosRequester {
    return new AxiosRequester(id);
  }
}
